import I18n from 'I18n';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';

// TODO: update with the right type once the type is available in the client types

export const getGroupedRevisionOptions = groupedRevisionResults => {
  const options = [];
  let currentGroupId = -1;
  // set the end limit timestamp for each option.
  let currentRevisionEndTimestamp = Date.now();
  groupedRevisionResults === null || groupedRevisionResults === void 0 || groupedRevisionResults.forEach(currentRevision => {
    if (currentRevision.groupId !== currentGroupId) {
      currentGroupId = currentRevision.groupId;
      options.push({
        text: I18n.text('automation.enrollmentHistory.panel.enrollment-list.filter.revisionFilter.groupHeader'),
        value: currentGroupId,
        groupId: currentRevision.groupId,
        disabled: true
      });
    }
    const dateContent = I18n.moment[TimezoneTypes.PORTAL](currentRevision.timestamp).format('L');
    const timeContent = I18n.moment[TimezoneTypes.PORTAL](currentRevision.timestamp).format('LT z');
    options.push({
      text: `${dateContent} ${timeContent}`,
      value: currentRevision.timestamp,
      groupId: currentRevision.groupId,
      endLimitTimestamp: currentRevisionEndTimestamp,
      version: currentRevision.version
    });
    currentRevisionEndTimestamp = currentRevision.timestamp;
  });
  return options;
};
export const getFilteredToGroupedRevisionOptions = (fromGroupedRevisionOptions, fromValue) => {
  if (!fromGroupedRevisionOptions.length) {
    return [];
  }
  let allowedGroupId = -1;
  if (!fromValue) {
    var _fromGroupedRevisionO;
    allowedGroupId = fromGroupedRevisionOptions[0].groupId;
    fromValue = (_fromGroupedRevisionO = fromGroupedRevisionOptions.findLast(option => option.groupId === allowedGroupId)) === null || _fromGroupedRevisionO === void 0 ? void 0 : _fromGroupedRevisionO.value;
  } else {
    var _fromGroupedRevisionO2, _fromGroupedRevisionO3;
    allowedGroupId = (_fromGroupedRevisionO2 = fromGroupedRevisionOptions === null || fromGroupedRevisionOptions === void 0 || (_fromGroupedRevisionO3 = fromGroupedRevisionOptions.find(option => option.value === fromValue)) === null || _fromGroupedRevisionO3 === void 0 ? void 0 : _fromGroupedRevisionO3.groupId) !== null && _fromGroupedRevisionO2 !== void 0 ? _fromGroupedRevisionO2 : -1;
  }
  return fromGroupedRevisionOptions.filter(option => {
    return option.groupId === allowedGroupId && (option.disabled || option.value >= fromValue);
  });
};
export const mergeNextPageOptions = (currentOptions, nextPageOptions) => {
  var _nextPageOptions$, _currentOptions;
  const nextPageGroupedRevisionOptions = getGroupedRevisionOptions(nextPageOptions);
  let mergedOptions = [];
  const shouldMergeWithLastGroup = ((_nextPageOptions$ = nextPageOptions[0]) === null || _nextPageOptions$ === void 0 ? void 0 : _nextPageOptions$.groupId) === ((_currentOptions = currentOptions[currentOptions.length - 1]) === null || _currentOptions === void 0 ? void 0 : _currentOptions.groupId);
  if (shouldMergeWithLastGroup) {
    // remove header option from next page
    nextPageGroupedRevisionOptions.shift();
  }
  mergedOptions = currentOptions.concat(nextPageGroupedRevisionOptions);
  return mergedOptions;
};
export const getChangedActionsByVersion = groupedRevisionResults => {
  const changedActionsByVersion = {};
  groupedRevisionResults === null || groupedRevisionResults === void 0 || groupedRevisionResults.forEach(currentRevision => {
    var _currentRevision$audi;
    const auditEvents = (_currentRevision$audi = currentRevision === null || currentRevision === void 0 ? void 0 : currentRevision.auditEvents) !== null && _currentRevision$audi !== void 0 ? _currentRevision$audi : [];
    auditEvents.forEach(auditEvent => {
      if (['ACTION_METADATA_MODIFIED', 'ENROLLMENT_MODIFIED'].includes(auditEvent.type)) {
        var _changedActionsByVers;
        const currentRevisionChanges = (_changedActionsByVers = changedActionsByVersion[currentRevision.version]) !== null && _changedActionsByVers !== void 0 ? _changedActionsByVers : [];
        if (auditEvent.type === 'ACTION_METADATA_MODIFIED') {
          var _auditEvent$actionIds;
          (_auditEvent$actionIds = auditEvent.actionIds) === null || _auditEvent$actionIds === void 0 || _auditEvent$actionIds.forEach(actionId => currentRevisionChanges.push(actionId.toString()));
        } else {
          currentRevisionChanges.push('enrollment');
        }
        changedActionsByVersion[currentRevision.version] = currentRevisionChanges;
      }
    });
  });
  return changedActionsByVersion;
};
export const getChangedActionsForVersionRange = (changedActionsByVersion, fromVersion, toVersion) => {
  if (!fromVersion || !toVersion) {
    return [];
  }
  let changedActions = [];
  // Note: Starting with the next version after the fromVersion. Because we are interested in the enrollments which happened from the fromVersion created timestamp.
  for (let currentVersion = fromVersion + 1; currentVersion <= toVersion; currentVersion++) {
    if (changedActionsByVersion[currentVersion]) {
      changedActions = changedActions.concat(changedActionsByVersion[currentVersion]);
    }
  }
  // removes duplicates
  return Array.from(new Set(changedActions));
};